import { config } from '@iheartjane/config';

export const getCurrentStoreSpecials = (
  storeId?: string | number,
  sort?: string
) => {
  if (!storeId) return null;

  const url = `${config.apiPath}/stores/${storeId}/specials`;
  return { url: sort ? `${url}?sort=${sort}` : url };
};
